<template>
  <div class="register-form">
    <div class="rf-title">参展信息</div>
    <Form
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      label-position="right"
      :label-width="150"
      @submit.native.prevent
    >
      <FormItem label="产品类别：" prop="type">
        <Select
          v-model="formInline.type"
          filterable
          placeholder="产品类别"
          multiple
          @on-change="selectChange"
        >
          <Option v-for="item in exTypeArr" :value="item.name" :key="item.name">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="展馆信息：" prop="type">
        <Select v-model="formInline.hall" filterable placeholder="展馆信息">
          <Option
            v-for="item in exHallArr"
            :value="item.name"
            :key="item.name"
          >{{ item.name }} - {{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="展位号：" prop="num">
        <Input type="text" v-model="formInline.num" placeholder="请输入展位号" />
      </FormItem>
      <br />
      <FormItem>
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('formInline')"
          long
          :loading="loading"
        >确定</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  // 参展信息
  name: "exhibition-join-info",
  props: {
    exhibition: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false, // 是否可以获取验证码
      formInline: {
        // form双向绑定
        type: [],
        hall: null,
        num: ""
      },
      ruleInline: {
        num: [{ required: true, message: "展位号不能为空", trigger: "blur" }]
      },
      exTypeArr: [], // 展商类别
      exHallArr: [], // 展商类别
      categories: []
    };
  },
  watch: {
    exhibition(val, oldVal) {
      console.log("exhibition: ", val);
      if (val) {
        this.init(val.id);
      }
    }
  },
  created() {},
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinEx: "companyModule/getJoinEx"
    })
  },
  methods: {
    ...mapActions({
      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      joinExhibition: "exhibitionModule/joinExhibition",
      getJoinExhibitionInfoByCompId:
        "exhibitionModule/getJoinExhibitionInfoByCompId",
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo"
    }),
    async init(id) {
      let hallData = await this.getHallByExhibition(id);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }
      let categoryData = await this.getCategoryByExhibition(id);
      if (categoryData && categoryData.length) {
        this.exTypeArr = categoryData;
      } else {
        this.exTypeArr = [];
      }
      if (
        (this.exHallArr && this.exHallArr.length) ||
        (this.exTypeArr && this.exTypeArr.length)
      ) {
        this.getInfo();
      } else {
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
      }
    }, 
    async handleSubmit(name) {
      if (!this.exhibition) {
        this.$Message.error("请选择展会！");
        return;
      }
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!this.formInline.hall) {
        this.$Message.error("展馆信息不能为空！");
      }
      this.categories = [];
      this.exTypeArr.forEach(v => {
        this.formInline.type.forEach((c, index) => {
          if (c === v.name && index <= 2) {
            this.categories.push({ Id: v.id, Value: v.name });
          }
        });
      });
      if (!this.formInline.hall) {
        this.$Message.error("展馆信息不能为空！");
        return;
      }
      if (this.categories && this.categories.length === 0) {
        this.$Message.error("产品类别不能为空！");
        return;
      }
      if (this.joinEx) {
        this.editSelect();
      } else {
        this.joinSelect();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async getInfo() {
      // 通过公司和展会id获取参展信息
      let data = await this.getJoinExhibitionInfoByCompId({
        compId: this.company.id,
        exhibitionId: this.exhibition.id
      });
      data.categories = data.categories ? JSON.parse(data.categories) : [];
      data.compInfo = data.compInfo ? JSON.parse(data.compInfo) : null;
      data.exInfo = data.exInfo ? JSON.parse(data.exInfo) : null; 
      if (
        data.categories &&
        data.categories.length &&
        this.exTypeArr &&
        this.exTypeArr.length
      ) {
        this.formInline.type = [];
        this.exTypeArr.forEach(v => {
          data.categories.forEach(c => {
            if (c.Value === v.name) {
              this.formInline.type.push(v.name);
            }
          });
        });
      }
      if (data.exHall) {
        this.formInline.hall = data.exHall;
      }
      if (data.boothCode) {
        this.formInline.num = data.boothCode;
      }
    },
    selectChange(e) {
      if (e && e.length > 3) {
        this.formInline.type = [e[0], e[1], e[2]];
      }
    },
    async joinSelect() {
      // 加入展会
      let formData = {
        CompId: this.company.id,
        ExhibitionId: this.exhibition.id,
        ExHall: this.formInline.hall,
        BoothCode: this.formInline.num,
        Categories: this.categories
      };
      this.loading = true;
      let bool = await this.joinExhibition(formData);
      this.loading = false;

      if (bool.successed) {
        this.$Message.success("操作成功");
        this.$router.push("/exhibition/index/home");
      } else {
        if (bool.errors && bool.errors[0]) {
          this.$Message.error(bool.errors[0].description);
          return;
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async editSelect() {
      // 修改参展信息
      let req = {
        Id: this.joinEx.joinId,
        SetValues: {
          ExHall: this.formInline.hall,
          BoothCode: this.formInline.num,
          Categories: JSON.stringify(this.categories)
        }
      };
      let bool = await this.putJoinExhibitionInfo(req);

      if (bool.successed) {
        this.$Message.success("操作成功");
        this.$router.push("/exhibition/index/home");
      } else {
        if (bool.errors && bool.errors[0]) {
          this.$Message.error(bool.errors[0].description);
          return;
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.register-form {
  font-size: 14px;
  width: 600px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}
</style>